var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-template',[_c('board',{attrs:{"is-fold":_vm.isFold,"http-options":_vm.httpOptions,"config":_vm.config,"insert-row-function":function () { return _vm.insertRow('createEmptyCuration'); },"delete-row-function":function (rows) { return _vm.deleteRow('deleteCurations', rows); },"disabled-play-button":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7466d518","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/components/board/curation/BoardCuration.vue
// module id = null
// module chunks = 